import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pnc_ic_zscw",
  "use": "icon-pnc_ic_zscw-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol viewBox=\"0 0 44 44\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pnc_ic_zscw\"><circle cx=\"22\" cy=\"22\" fill=\"#f5943d\" r=\"18\" /><path d=\"m16.7 13.9v17.1h2.8v-6.6h4.2c4.2 0 6.3-1.8 6.3-5.3s-2.1-5.3-6.2-5.3h-7.1zm2.8 2.4h4.1c1.2 0 2.1.2 2.7.7.6.4.9 1.2.9 2.2s-.3 1.8-.9 2.2-1.5.7-2.7.7h-4.1z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pnc_ic_zscw.svg
// module id = I/mA
// module chunks = 87